module.exports = __webpack_public_path__ + "static/media/tort_logo.418e4301.png";